<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form">
            <el-form-item label="任务：" class="query-form-item">
                <el-select v-model="query.content" placeholder="请选择" clearable filterable style="width: 150px">
                    <el-option
                        v-for="item in contentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="执行人员：" class="query-form-item">
                <el-select v-model="query.executor_id" placeholder="请选择" clearable filterable style="width: 120px">
                    <el-option
                        v-for="item in executorOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序字段：" class="query-form-item">
                <el-select v-model="query.order_field" placeholder="排序字段" clearable style="width: 140px">
                    <el-option label="创建时间" value="created"></el-option>
                    <el-option label="更新时间" value="updated"></el-option>
                    <el-option label="截止时间" value="dueDate"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序类型：" class="query-form-item">
                <el-select v-model="query.order_type" placeholder="排序类型" clearable style="width: 120px">
                    <el-option label="升序" value="asc"></el-option>
                    <el-option label="降序" value="desc"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <div v-if="listRemark" ref="remarkRow" class="list-remark-row">备注: {{ listRemark }}</div>
        <el-table
            :height="tableHeight"
            v-loading="loading"
            :data="list"
            stripe
            border
            style="width: 100%">
            <el-table-column prop="content" label="任务" align="center" min-width="120"></el-table-column>
            <el-table-column prop="executor" label="执行人员" align="center" width="100"></el-table-column>
            <el-table-column prop="note" label="备注" align="center" min-width="120"></el-table-column>
            <el-table-column prop="created" label="创建时间" align="center" width="170"></el-table-column>
            <el-table-column prop="updated" label="更新时间" align="center" width="170"></el-table-column>
            <el-table-column label="截止时间" align="center" width="170">
                <template slot-scope="scope">
                    <span v-if="scope && scope.row.dueDate" :class="{ 'urgent-text': (new Date(scope.row.dueDate) - new Date()) / 36e5 < 24}"
                            >
              {{ scope.row.dueDate }}
            </span>
                </template>
            </el-table-column>

            <el-table-column prop="create_time" label="刷新时间" align="center" width="170"></el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="160">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="showDetail(scope.row)">详细</el-button>
                    <el-button type="text" size="mini" @click="handleFinish(scope.row)">完成</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[10, 20, 50]"
            :total="total"
            background
            :current-page="query.page"
            style="margin-top: 10px; display: flex; justify-content: flex-end;"
            layout="total, sizes, prev, pager, next">
        </el-pagination>

        <!-- 详细弹窗 -->
        <el-dialog title="详细信息" :visible.sync="detailDialogVisible" width="560px" class="detail-dialog">
            <div class="detail-content" v-if="detailItems.length">
                <div class="detail-row" v-for="item in detailItems" :key="item.label">
                    <span class="detail-label">{{ item.label }}</span>
                    <div class="detail-value" v-if="item.isList">
                        <div class="detail-note-item" v-for="(line, idx) in item.lines" :key="idx">{{ line }}</div>
                    </div>
                    <span class="detail-value" v-else>{{ item.value }}</span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false" size="mini">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 完成确认弹窗 -->
        <el-dialog title="完成任务" :visible.sync="finishDialogVisible" width="400px">
            <p>确定要完成该任务吗？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="finishDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="finishLoading" @click="confirmFinish" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                tableHeight: null,
                query: {
                    content: '',
                    executor_id: '',
                    order_field: '',
                    order_type: '',
                    page: 1,
                    limit: 20
                },
                contentOptions: [],
                executorOptions: [],
                list: [],
                total: 0,
                loading: true,
                detailDialogVisible: false,
                detailItems: [],
                finishDialogVisible: false,
                finishLoading: false,
                currentRow: null,
                listRemark: ''
            }
        },
        methods: {
            loadListRemark() {
                api.config_common_get_config_value_by_key({ key: 'teambition_remind_list_remark' })
                    .then(res => {
                        const d = res.data
                        this.listRemark = typeof d === 'string' ? d : (d && d.value != null ? String(d.value) : '')
                        this.$nextTick(this.calcTableHeight)
                    })
                    .catch(() => {
                        this.listRemark = ''
                    })
            },
            calcTableHeight() {
                const formH = this.$refs.form && this.$refs.form.$el ? this.$refs.form.$el.offsetHeight : 0
                const remarkH = this.$refs.remarkRow ? this.$refs.remarkRow.offsetHeight : 0
                this.tableHeight = window.innerHeight - 145 - formH - remarkH
            },
            loadContentOptions() {
                api.teambition_common_get_remind_content_lists({})
                    .then(res => {
                        const data = res.data || {}
                        const list = data.list || data
                        // content API 返回字符串数组
                        this.contentOptions = list.map(item => ({
                            label: item,
                            value: item
                        }))
                    })
                    .catch(() => {
                        this.contentOptions = []
                    })
            },
            loadExecutorOptions() {
                api.teambition_common_get_remind_executor_lists({})
                    .then(res => {
                        const data = res.data || {}
                        this.executorOptions = Object.entries(data).map(([key, value]) => ({
                            label: value,
                            value: key
                        }))
                    })
                    .catch(() => {
                        this.executorOptions = []
                    })
            },
            showDetail(row) {
                this.detailItems = this.getDetailItems(row)
                this.detailDialogVisible = true
            },
            getDetailItems(row) {
                const labels = {
                    content: '任务',
                    note: '备注',
                    created: '创建时间',
                    updated: '更新时间',
                    dueDate: '截止时间',
                    create_time: '刷新时间',
                    executor: '执行人'
                }
                const hidden = ['id', 'page', 'limit', 'executorId']
                const order = ['content', 'note', 'created', 'updated', 'dueDate', 'create_time', 'executor']
                const items = []
                order.forEach(key => {
                    if (hidden.includes(key)) return
                    const value = row[key]
                    if (value === null || value === undefined || value === '') return
                    const label = labels[key] || key
                    items.push({ label, value: value || "", isList: false })
                })
                return items
            },
            handleFinish(row) {
                this.currentRow = row
                this.finishDialogVisible = true
            },
            confirmFinish() {
                if (!this.currentRow) return
                this.finishLoading = true
                api.admin_teambition_remind_finish_task({
                    id: this.currentRow.id,
                    page: this.query.page,
                    limit: this.query.limit
                })
                    .then(res => {
                        this.finishLoading = false
                        if(res.success) {
                            this.$message.success('更新成功')
                        } else {
                            this.$message.error('更新失败')
                        }
                        this.finishDialogVisible = false
                        this.getList()
                    })
                    .catch(() => {
                        this.finishLoading = false
                    })
            },
            onReset() {
                this.query = {
                    content: '',
                    executor_id: '',
                    order_field: '',
                    order_type: '',
                    page: 1,
                    limit: 20
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                const tempQuery = JSON.parse(JSON.stringify(this.query))
                if (!tempQuery.content) delete tempQuery.content
                if (!tempQuery.executor_id) delete tempQuery.executor_id
                if (!tempQuery.order_field) delete tempQuery.order_field
                if (!tempQuery.order_type) delete tempQuery.order_type
                api.admin_teambition_remind_manager_lists(tempQuery)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                    })
            }
        },
        mounted() {
            this.$nextTick(this.calcTableHeight)
            const that = this
            window.onresize = () => that.calcTableHeight()
        },
        created() {
            this.loadListRemark()
            this.loadContentOptions()
            this.loadExecutorOptions()
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    .detail-content {
        padding: 8px 0;
    }
    .detail-row {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
        border-bottom: 1px solid #ebeef5;
        line-height: 1.5;
    }
    .detail-row:last-child {
        border-bottom: none;
    }
    .detail-label {
        flex-shrink: 0;
        width: 90px;
        color: #909399;
        font-size: 13px;
    }
    .detail-value {
        flex: 1;
        color: #303133;
        font-size: 13px;
        word-break: break-all;
    }
    .detail-note-item {
        padding: 4px 0;
        padding-left: 12px;
        position: relative;
    }
    .detail-note-item::before {
        content: '·';
        position: absolute;
        left: 0;
        color: #909399;
    }
    .list-remark-row {
        padding: 10px 16px;
        margin-bottom: 10px;
        background-color: #fdf6ec;
        border: 1px solid #f5dab1;
        border-radius: 4px;
        font-size: 13px;
        color: #e6a23c;
        line-height: 1.6;
    }
    .urgent-text {
        color: red;
        font-weight: bold;
    }

</style>
